// extracted by mini-css-extract-plugin
export default {"headerWrapper":"style_headerWrapper__mitpZ","logoBlock":"style_logoBlock__s-aUy"};